<template>
    <v-container fluid fill-height pa-0>
        <iframe class="storymap"
                :src="mapURL"></iframe>
    </v-container>
</template>

<script>
    export default {
        name: 'Story',
        props: ["mapURL"]
    }
</script>

<style>
    .storymap {
        width: 100%;
        height: 100%;
        border: 0;
    }

    html {
        overflow-y: hidden;
    }
</style>